<template>
  <div class="receipt-container">
    <div class="receipt" style="padding-top: 100px;">
      <!-- Header Section -->
      <div class="receipt-line" style="text-align: right; width: 300px;">
        {{ loadedTransaction.userPK_TransH?.toString().padStart(8, ' ') || '' }}
      </div>
     
      <div class="receipt-line" style="text-align: left; padding-left: 12ch;">
        {{ formatDate(loadedTransaction.dateIssue_TransH) || '' }}
      </div>
       <div class="receipt-line">
      <br/>
      </div>
      <div  style="text-align: left; padding-left: 30px; margin-top: 20px; ">
        {{loadedTransaction.nameFull_UM_TransH}}
      </div>
      <div class="receipt-line">
      <br/>
      </div>
    
      <!-- Transaction Items -->
      <div v-for="item,index in selectedCollections" :key="index" class="receipt-item" style="margin-top: 15px;">
        <div  v-if="(item.userPK_PM === 'WB' || item.userPK_PM === 'PLTY') && item.dateBillingPeriod_ColTypeEntries !== null" class="receipt-line">
          <span style="width: 28ch; display: inline-block; text-align: left;" class="text-wrap">
            {{item.description_PM}}
          </span>
          <span style="width: 7ch; display: inline-block; text-align: left;" class="align-top">
            {{item.userPK_PM}}
          </span>
          <span style="width: 10ch; display: inline-block; text-align: right;" class="align-top">
            {{$formatters.formatNumber(item.amountNet_ColTypeEntries)}}
          </span>
          <span v-if="item.userPK_PM === 'TC' || item.userPK_PM === 'TOT' || item.userPK_PM === 'TF' || item.userPK_PM === 'CTCTD'">
            <br/>TD: {{ item.userFK_GenericClass_ColTypeEntries }} {{ item.userFK_Revision_ColTypeEntries }}
          </span>
        </div>
        <div  v-else class="receipt-line">
          <span style="width: 28ch; display: inline-block; text-align: left;" class="text-wrap">
            {{item.description_PM}}
          </span>
          <span style="width: 7ch; display: inline-block; text-align: left;" class="align-top">
            {{item.userPK_PM}}
          </span>
          <span style="width: 10ch; display: inline-block; text-align: right;" class="align-top">
            {{$formatters.formatCurrencyWithoutSymbol(item.amountNet_ColTypeEntries)}}
          </span>
          <span v-if="item.userPK_PM === 'TC' || item.userPK_PM === 'TOT' || item.userPK_PM === 'TF' || item.userPK_PM === 'CTCTD'">
            <br/>TD: {{ item.userFK_GenericClass_ColTypeEntries }} {{ item.userFK_Revision_ColTypeEntries }}
          </span>
        </div>
      </div>
      
      <!-- Total Amount -->
      <div  style="text-align: right; width: 360px; position: absolute; top: 460px">
         {{$formatters.formatCurrency(loadedTransaction.totalAmount_TransH)}}
      </div>
      
      <!-- Amount in words -->
      <div  style="margin-top: 5px; padding-left: 0; font-size: 10px; position: absolute; top: 480px; width: 380px;">
        <span class="text-wrap">
        {{convertToWord(loadedTransaction.totalAmount_TransH || 0)}}
            </span>
      </div>
      
      <!-- Payment type -->
      <div class="receipt-line" style="margin-top: 5px; padding-left: 0; position: absolute; top: 510px;">
       <span v-if="loadedTransaction.payType_TransH === 'Cash'">☑ Cash</span>
<span v-else-if="loadedTransaction.payType_TransH === 'Check'">☑ Check</span>
<span v-else>☑ Others</span>
      </div>
      
      <!-- Cashier name -->
      <div class="receipt-line" style="padding-left: 160px; position: absolute; top: 560px;">
        {{loadedTransaction.inChargedBy_TransH}}
      </div>
    </div>
  </div>
</template>


<script setup>
  /* eslint-disable */
 import {computed,defineProps,defineExpose} from "vue"
 
 const props = defineProps({
    loadedTransaction: {
      type: Object,
      required: true
    },
    selectedCollections: {
      type: Array,
      required: true
    },
    isInLieu: {
      type: Boolean,
      default: false
    }
  });

defineExpose({
  printReceipt
});

   function concessionaireLines() {
      const name = props.loadedTransaction.NameFull_UM_TransH || 
                  props.loadedTransaction.NameFull_AcctMstr_TransH || 
                  '';
      const maxLength = 33;
      const lines = [];
      
      if (name.length > maxLength) {
        const lineCount = Math.ceil(name.length / maxLength);
        for (let i = 0; i < lineCount; i++) {
          const start = i * maxLength;
          const end = (i === lineCount - 1) ? name.length : start + maxLength;
          lines.push(name.substring(start, end));
        }
      } else {
        lines.push(name);
      }
      
      return lines;
    }
   function emptyLinesAfterConcessionaire() {
      return Math.max(0, 4 - this.concessionaireLines.length);
    }
    function emptyLinesAfterItems() {
      return Math.max(0, 11 - this.selectedCollections.reduce((count, ct) => {
        count++; // main line
        if (ct.Description_PM?.length > 27) count++;
        if (ct.Description_PM?.length > 74) count++;
        if (ct.AmountDiscount_ColtypeEntries > 0) count++;
        if (this.isTaxItem(ct)) count++;
        return count;
      }, 0));
    }
 const amountInWords = computed(()=> {
      const amount = props.loadedTransaction.TotalAmount_TransH || 0;
      alert(amount)
      return convertToWord(amount);
    })
   function isCashPayment() {
      return props.loadedTransaction.payType_TransH?.toLowerCase().includes('cash');
    }
   function isCheckPayment() {
      return props.loadedTransaction.payType_TransH?.toLowerCase().includes('check');
    }
    const checkNumber = computed(()=> {
      if (!props.loadedTransaction.accountDocumentNum_TransH) return '';
      const num = props.loadedTransaction.accountDocumentNum_TransH;
      return num.length > 6 ? num.substring(num.length - 6) : num;
    })
    const  checkDate = computed(()=> {
      if (!props.loadedTransaction.dateAccountDocument_TransH) return '';
      return this.formatDate(props.loadedTransaction.dateAccountDocument_TransH);
    })
  const  cashierName = computed(()=> {
      return 'Form51Cashier'; // Replace with your actual cashier name setting
    })
   function formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      return `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}/${d.getFullYear()}`;
    }
    function getFirstLineDescription(ct) {
      if ((ct.userPK_PM === 'WB' || ct.userPK_PM === 'PLTY') && ct.dateBillingPeriod_ColTypeEntries) {
        return `${ct.description_PM?.trim() || ''}-${this.formatDate(ct.dateBillingPeriod_ColTypeEntries)}`.padEnd(28, ' ');
      }
      const desc = ct.description_PM?.trim() || '';
      return desc.length > 27 ? desc.substring(0, 27) : desc.padEnd(28, ' ');
    }
    function getSecondLineDescription(ct) {
      const desc = ct.description_PM?.trim() || '';
      if (desc.length > 27) {
        return desc.substring(27, Math.min(27 + 46, desc.length)).padEnd(28, ' ');
      }
      return '';
    }
    function getThirdLineDescription(ct) {
      const desc = ct.description_PM?.trim() || '';
      if (desc.length > 74) {
        return desc.substring(73).padEnd(28, ' ');
      }
      return '';
    }
   function getDiscountDescription(ct) {
      if (ct.dateBillingPeriod_ColTypeEntries) {
        return `Discount-${this.formatDate(ct.dateBillingPeriod_ColTypeEntries)}`.padEnd(28, ' ');
      }
      return 'Discount'.padEnd(28, ' ');
    }
    function isTaxItem(ct) {
      return ['TC', 'TOT', 'TF', 'CTCTD'].includes(ct.userPK_PM);
    }
     // eslint-disable-next-line
  function convertToWord(number) {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  function convertLessThanOneThousand(number) {
    if (number === 0) return '';
    if (number < 10) return ones[number];
    if (number < 20) return teens[number - 10];
    if (number < 100) {
      return tens[Math.floor(number / 10)] + (number % 10 !== 0 ? ' ' + ones[number % 10] : '');
    }
    return ones[Math.floor(number / 100)] + ' Hundred' + (number % 100 !== 0 ? ' ' + convertLessThanOneThousand(number % 100) : '');
  }

  // Split into pesos and centavos
  const parts = number.toString().split('.');
  let pesos = parseInt(parts[0]);
  let centavos = parts.length > 1 ? parseInt(parts[1].padEnd(2, '0').substring(0, 2)) : 0;

  if (isNaN(pesos)) pesos = 0;
  if (isNaN(centavos)) centavos = 0;

  if (pesos === 0 && centavos === 0) {
    return 'Zero Pesos Only';
  }

  let result = '';
  
  // Convert pesos part
  if (pesos > 0) {
    if (pesos >= 1000000) {
      const millions = Math.floor(pesos / 1000000);
      result += convertLessThanOneThousand(millions) + ' Million';
      pesos %= 1000000;
      if (pesos > 0) result += ' ';
    }
    
    if (pesos >= 1000) {
      const thousands = Math.floor(pesos / 1000);
      result += convertLessThanOneThousand(thousands) + ' Thousand';
      pesos %= 1000;
      if (pesos > 0) result += ' ';
    }
    
    if (pesos > 0) {
      result += convertLessThanOneThousand(pesos);
    }
    
    result += ' Pesos';
  }

  // Convert centavos part
  if (centavos > 0) {
    if (pesos > 0) {
      result += ' and ';
    }
    result += convertLessThanOneThousand(centavos) + ' Centavos';
  }

  return result + ' Only';
}
   function printReceipt() {
      // Implement printing logic here
      window.print();
    }
</script>

<style>
.receipt-container {
     font-family: 'Courier New', monospace;
 width: 210mm;
  height: 297mm;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  position: relative;
  overflow: hidden;
}

.receipt {
  font-family: inherit;
  white-space: pre;
  line-height: 1;
  font-size: 14px;
  padding: 20px 10px;
  width: 100%;
}

.receipt-line {
  font-family: inherit;
  line-height: 1.2;
  margin: 2px 0;
}

@media print {
  /* Reset all margins for printing */
  @page {
    size: A4;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }

  /* Hide everything except the receipt */
  body * {
    visibility: hidden;
  }

  /* Show only receipt container and its children */
  .receipt-container, .receipt-container * {
    visibility: visible;
  }

  /* Position receipt at top-left of page */
  .receipt-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    page-break-after: avoid; /* Prevent page break after */
    page-break-inside: avoid; /* Prevent splitting receipt */
  }


}
</style>